module.exports = __webpack_public_path__ + "img/yjzq-j10n_18.prt.16c1044d.jpg";